import React from 'react'
import { CollapsibleSection } from '../UI/CollapsibleSection/CollapsibleSection'
import { Chain } from '../../models/chains'
import { formatInteger } from '../../utils/formatting'
import { ClientDataTable } from '../ClientDataTable/ClientDataTable'
import { Anchor } from '../UI/Anchor'

interface IChainMenuCardProps {
  instagram?: Chain['instagram']
}

export function ChainIGSection(props: IChainMenuCardProps) {
  if (!props.instagram) {
    return null
  }

  return (
    <CollapsibleSection summary={<>Instagram</>}>
      <ClientDataTable
        data={[props.instagram]}
        enableSorting={false}
        columns={[
          {
            id: 'instagram_url',
            accessorKey: 'url',
            header: 'Instagram Handle',
            cell: (info) => {
              let value = info.getValue()
              if (!value) return '-'

              // Get handle from value, value is a url that can end on / or not
              if (value.endsWith('/')) {
                value = value.slice(0, -1)
              }
              const handle = '@' + value.split('/').pop()

              return (
                <Anchor href={'//' + value} target="_blank">
                  {handle}
                </Anchor>
              )
            },
          },
          {
            accessorKey: 'followers',
            header: 'Followers',
            cell: (info) => {
              const value = info.getValue()
              if (!value) return 'N/A'

              return formatInteger(value)
            },
          },
          {
            accessorKey: 'following',
            header: 'Following',
            cell: (info) => {
              const value = info.getValue()
              if (!value) return 'N/A'

              return formatInteger(value)
            },
          },
          {
            accessorKey: 'posts',
            header: 'Posts',
          },
        ]}
      />
    </CollapsibleSection>
  )
}
